import React, { useState } from 'react';
import {
  Container,
  Grid,
  Typography,
  Button,
  Card,
  CardContent,
  CardMedia,
  Box,
  Divider,List,ListItem,ListItemText,Paper,ListItemIcon,
  Tabs,
  Tab,Link,Breadcrumbs
} from '@mui/material';
import Webhead from './Webhead';
import qq from './img/qq.jpeg'
import course1 from './img/course1.jpg';
import course2 from './img/course2.jpg';
import course3 from './img/course3.jpg';
import course4 from './img/course4.jpg';
import course5 from './img/course5.jpg';
import course6 from './img/course6.jpg';
import course7 from './img/course7.jpg';
import course8 from './img/course8.jpg';
import course9 from './img/course9.jpg';
import course10 from './img/course10.jpg';
import course11 from './img/course11.jpeg';
import HD2 from './img/HD1.jpg';
import HD1 from './img/HD2.jpg';
import HD3 from './img/HD3.jpg';
import D1 from './img/D1.jpg';
import D2 from './img/D2.jpg';
import D3 from './img/D3.jpg';
import D4 from './img/D4.jpg';
import D5 from './img/D5.jpg';
import D6 from './img/D6.jpg';
import D8 from './img/D8.jpg';
import Footer from './Webfoot'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';


const Courses = () => {
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [imageHidden, setImageHidden] = useState(false);
  const [tabValue, setTabValue] = useState(0); // State for tab selection


// Course categories
const courseCategories = [
  {
  
      label: "Diploma Courses",
      courses: [
        {
          title: "Diploma in Civil Engineering",
          image: course1,
          description: "A comprehensive course in Civil Engineering.",
          details: "– Duration: 1 – 3 years\n– Medium: English\n– Language Mode: Online/Study Centre\n– Fee: Contact Centre\n– Tutor-Marked Assessment\n– Validated by University/Institution\n– Proctored Examination Online Verification"
        },
        {
          title: "Diploma in Electrical Engineering",
          image: course2,
          description: "A course focusing on Electrical Engineering fundamentals.",
          details: "– Duration: 1 – 3 years\n– Medium: English\n– Language Mode: Online/Study Centre\n– Fee: Contact Centre\n– Tutor-Marked Assessment\n– Validated by University/Institution\n– Proctored Examination Online Verification"
        },
        {
          title: "Diploma in Mechanical Engineering",
          image: course3, // Assuming img5 is imported for this course
          description: "An in-depth course covering Mechanical Engineering principles.",
          details: "– Duration: 1 – 3 years\n– Medium: English\n– Language Mode: Online/Study Centre\n– Fee: Contact Centre\n– Tutor-Marked Assessment\n– Validated by University/Institution\n– Proctored Examination Online Verification"
        },
        {
          title: "Diploma in Computer Engineering",
          image: course4, // Assuming img5 is imported for this course
          description: "An in-depth course covering Computer Engineering principles.",
          details: "– Duration: 1 – 3 years\n– Medium: English\n– Language Mode: Online/Study Centre\n– Fee: Contact Centre\n– Tutor-Marked Assessment\n– Validated by University/Institution\n– Proctored Examination Online Verification"
        },
        {
          title: "Diploma in Engineering Management",
          image: course5, // Assuming img6 is imported for this course
          description: "A course designed for future engineering managers.",
          details: "– Duration: 1 – 3 years\n– Medium: English\n– Language Mode: Online/Study Centre\n– Fee: Contact Centre\n– Tutor-Marked Assessment\n– Validated by University/Institution\n– Proctored Examination Online Verification"
        },
        {
          title: "Diploma in Hospitality Management",
          image: course6, // Assuming img7 is imported for this course
          description: "Focus on management skills in the hospitality sector.",
          details: "– Duration: 1 – 3 years\n– Medium: English\n– Language Mode: Online/Study Centre\n– Fee: Contact Centre\n– Tutor-Marked Assessment\n– Validated by University/Institution\n– Proctored Examination Online Verification"
        },
        {
          title: "Diploma in Culinary Arts",
          image: course7, // Assuming img8 is imported for this course
          description: "Learn the art of cooking with professional techniques.",
          details: "– Duration: 1 – 3 years\n– Medium: English\n– Language Mode: Online/Study Centre\n– Fee: Contact Centre\n– Tutor-Marked Assessment\n– Validated by University/Institution\n– Proctored Examination Online Verification"
        },
        {
          title: "Diploma in Retail Management",
          image: course8, // Assuming img9 is imported for this course
          description: "Training for managing retail operations effectively.",
          details: "– Duration: 1 – 3 years\n– Medium: English\n– Language Mode: Online/Study Centre\n– Fee: Contact Centre\n– Tutor-Marked Assessment\n– Validated by University/Institution\n– Proctored Examination Online Verification"
        },
        {
          title: "Diploma in Retail and Sales Management",
          image: course9, // Assuming img10 is imported for this course
          description: "Emphasis on sales techniques and retail strategies.",
          details: "– Duration: 1 – 3 years\n– Medium: English\n– Language Mode: Online/Study Centre\n– Fee: Contact Centre\n– Tutor-Marked Assessment\n– Validated by University/Institution\n– Proctored Examination Online Verification"
        },
        {
          title: "Diploma in Hospitality and Tourism Management",
          image: course10, // Assuming img11 is imported for this course
          description: "Management skills for the hospitality and tourism industry.",
          details: "– Duration: 1 – 3 years\n– Medium: English\n– Language Mode: Online/Study Centre\n– Fee: Contact Centre\n– Tutor-Marked Assessment\n– Validated by University/Institution\n– Proctored Examination Online Verification"
        },
        {
          title: "Advanced Diploma in Accounts",
          image: course11, // Assuming img12 is imported for this course
          description: "Deep dive into accounting principles and practices.",
          details: "– Duration: 1 – 3 years\n– Medium: English\n– Language Mode: Online/Study Centre\n– Fee: Contact Centre\n– Tutor-Marked Assessment\n– Validated by University/Institution\n– Proctored Examination Online Verification"
        },
      ]
  
    
  },


  {
    label: "Higher Diploma Courses",
    courses: [
      {
        title: "Higher Diploma in Civil Engineering",
        image: HD2, // Assuming img12 is imported for this course
        description: "Advanced course in Civil Engineering.",
        details: "– Duration: 1 – 3 years\n– Medium: English\n– Language Mode: Online/Study Centre\n– Fee: Contact Centre\n– Tutor-Marked Assessment\n– Validated by University/Institution\n– Proctored Examination Online Verification"
      },
      {
        title: "Higher Diploma in Mechanical Engineering",
        image: HD1, // Assuming img12 is imported for this course
        description: "Advanced course in Mechanical Engineering.",
        details: "– Duration: 1 – 3 years\n– Medium: English\n– Language Mode: Online/Study Centre\n– Fee: Contact Centre\n– Tutor-Marked Assessment\n– Validated by University/Institution\n– Proctored Examination Online Verification"
      },
      {
        title: "Higher Diploma in Electrical Engineering",
        image: HD3, // Assuming img12 is imported for this course
        description: "Advanced course in Electrical Engineering.",
        details: "– Duration: 1 – 3 years\n– Medium: English\n– Language Mode: Online/Study Centre\n– Fee: Contact Centre\n– Tutor-Marked Assessment\n– Validated by University/Institution\n– Proctored Examination Online Verification"
      },


   
    ],
  },
  {
    label: "Post Graduate Diploma",
    courses: [
      { title: "Post Graduate Diploma in Engineering Management", image: course5, description: "Management principles for engineers.",              details: "– Duration: 1 – 3 years\n– Medium: English\n– Language Mode: Online/Study Centre\n– Fee: Contact Centre\n– Tutor-Marked Assessment\n– Validated by University/Institution\n– Proctored Examination Online Verification"},
      { title: "Post Graduate Diploma in Hospitality Management", image: course6, description: "Management practices in the hospitality industry.", details: "– Duration: 1 – 3 years\n– Medium: English\n– Language Mode: Online/Study Centre\n– Fee: Contact Centre\n– Tutor-Marked Assessment\n– Validated by University/Institution\n– Proctored Examination Online Verification"},
      { title: "Post Graduate Diploma in Culinary Arts", image: course7, description: "Learn advanced culinary techniques.",                        details: "– Duration: 1 – 3 years\n– Medium: English\n– Language Mode: Online/Study Centre\n– Fee: Contact Centre\n– Tutor-Marked Assessment\n– Validated by University/Institution\n– Proctored Examination Online Verification"},
      { title: "Post Graduate Diploma in Business Management", image: course9, description: "Business management principles.",                       details:"– Duration: 1 – 3 years\n– Medium: English\n– Language Mode: Online/Study Centre\n– Fee: Contact Centre\n– Tutor-Marked Assessment\n– Validated by University/Institution\n– Proctored Examination Online Verification" },
    ],
  },
  {
    label: "Degree Courses",
    courses: [
      { 
        title: "Bachelor of Technology (Civil Engineering)", 
        image: D1, 
        description: "Comprehensive engineering degree.",
        details: "– Duration: 1 – 3 years\n– Medium: English\n– Language Mode: Online/Study Centre\n– Fee: Contact Centre\n– Tutor-Marked Assessment\n– Validated by University/Institution\n– Proctored Examination Online Verification" 
      },
      { 
        title: "Bachelor of Technology (Electrical Engineering)", 
        image: D2, 
        description: "Comprehensive electrical engineering degree.",
        details: "– Duration: 1 – 3 years\n– Medium: English\n– Language Mode: Online/Study Centre\n– Fee: Contact Centre\n– Tutor-Marked Assessment\n– Validated by University/Institution\n– Proctored Examination Online Verification" 
      },
      { 
        title: "Bachelor of Technology (Mechanical Engineering)", 
        image: D3, 
        description: "Comprehensive mechanical engineering degree.",
        details: "– Duration: 1 – 3 years\n– Medium: English\n– Language Mode: Online/Study Centre\n– Fee: Contact Centre\n– Tutor-Marked Assessment\n– Validated by University/Institution\n– Proctored Examination Online Verification" 
      },
      { 
        title: "Bachelor of Science in Business Management (Hons)", 
        image: D4, 
        description: "Comprehensive business management degree.",
        details: "– Duration: 1 – 3 years\n– Medium: English\n– Language Mode: Online/Study Centre\n– Fee: Contact Centre\n– Tutor-Marked Assessment\n– Validated by University/Institution\n– Proctored Examination Online Verification" 
      },
      { 
        title: "Facilities Management", 
        image: D8, 
        description: "Focus on efficient building management and maintenance.",
        details: "– Duration: 1 – 3 years\n– Medium: English\n– Language Mode: Online/Study Centre\n– Fee: Contact Centre\n– Tutor-Marked Assessment\n– Validated by University/Institution\n– Proctored Examination Online Verification" 
      },
      { 
        title: "Construction Project Management", 
        image: course6, 
        description: "Learn to manage construction projects effectively.",
        details: "– Duration: 1 – 3 years\n– Medium: English\n– Language Mode: Online/Study Centre\n– Fee: Contact Centre\n– Tutor-Marked Assessment\n– Validated by University/Institution\n– Proctored Examination Online Verification" 
      },
      { 
        title: "Master of Business Administration (MBA)", 
        image: D5, 
        description: "Advanced business and management education.",
        details: "– Duration: 1 – 2 years\n– Medium: English\n– Language Mode: Online/Study Centre\n– Fee: Contact Centre\n– Tutor-Marked Assessment\n– Validated by University/Institution\n– Proctored Examination Online Verification" 
      },
      { 
        title: "Doctor of Philosophy (Ph.D.) in Business Administration", 
        image: D6, 
        description: "Research-focused doctorate in business administration.",
        details: "– Duration: 3 – 5 years\n– Medium: English\n– Language Mode: Online/Study Centre\n– Fee: Contact Centre\n– Thesis Submission and Defense\n– Validated by University/Institution\n– Proctored Examination Online Verification" 
      },
    ],
  },
  
  {
    label: "Certificate Courses",
    courses: [
      { title: "Foundation Courses in M&E Engineering" },
      { title: "Foundation Courses in Civil Engineering" },
      { title: "Foundation Courses in Facilities Management" },
      { title: "Certificate Course in AutoCAD 2D & 3D" },
      { title: "Certificate Course in Facility Management" },
      { title: "Certificate Course in Electrical System – LV and MV System" },
      { title: "Certificate Course in Advance Manufacturing/Mechatronics" },
      { title: "Certificate Course in Building Automation System (BAS/BMS)" },
      { title: "Certificate Course in Programmable and Logic Control (PLC)" },
      { title: "Certificate Course in M&E Equipment Maintenance and Operation" },
      { title: "Certificate Course in Air Conditioning & Mechanical Ventilation System (ACMV)" },
      { title: "Certificate Course in Project Management" },
      { title: "Certificate Course in Land Surveying" },
      { title: "Certificate Course in Quantity Surveying" },
      { title: "Certificate Course in Plumbing" },
      { title: "Certificate Course in Conventional English (at the Workplace)" },
      { title: "Certificate Course in Written Communication" },
      { title: "Certificate Course in Accounting & Finance" },
      { title: "Certificate Course in Basic MS Office Skills" },
      { title: "Certificate Course in Retail and Sales Management" },
      { title: "Certificate Course in Hospitality Management" },
      { title: "Certificate Course in Engineering Project Management" },
    ],

  },
  
];

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue); // Update the selected tab
    setSelectedCourse(null); // Reset the selected course when switching tabs
    setImageHidden(false); // Show the image again when switching tabs
  };

  const handleReadMore = (index) => {
    setSelectedCourse(index);
    setImageHidden(true);
  };

  const handleBack = () => {
    setImageHidden(false);
    setSelectedCourse(null);
  };

  const halfIndex = Math.ceil(courseCategories[tabValue].courses.length / 2); // Split index for the left and right columns

  return (
    <div>
      <Webhead />
      <div>
        <Container maxWidth="xl" sx={{ my: 6 }}>
          <Box
            sx={{
              backgroundImage: `url(${qq})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              py: 8,
              textAlign: 'center',
              color: 'white',
            }}
          >
            <Typography variant="h2" color="white" sx={{ fontWeight: 700 }}>
              Our Courses
            </Typography>
          </Box>

          <Typography
            variant="h3"
            color="primary"
            fontWeight={600}
            textAlign="center"
            gutterBottom
          >
            Explore Our Popular Online Courses
          </Typography>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
            }}
          >
            {courseCategories.map((category, index) => (
              <Tab
                key={index}
                label={category.label}
                sx={{
                  '&.Mui-selected': {
                    backgroundColor: 'primary.main',
                    color: 'white',
                    borderRadius: '4px 4px 0 0',
                  },
                  '&:hover': {
                    backgroundColor: 'primary.light',
                    color: 'white',
                  },
                  margin: '0 4px', // Adjust margin as needed
                }}
              />
            ))}
          </Tabs>
          <br />

          {/* Separate UI for 'Certificate Courses' */}
          {courseCategories[tabValue].label === 'Certificate Courses' ? (
        

<Grid
  container
  component={Paper}
  spacing={4}
  sx={{
    maxWidth: '1200px',
    margin: 'auto',
    padding: '16px',
    backgroundColor: '#f9f9f9',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
  }}
>
  <Grid item xs={12}>
    <Typography variant="h4" sx={{ mb: 2, textAlign: 'center', fontWeight: 600, color: 'primary.main' }}>
      Certificate Courses
    </Typography>
  </Grid>

  {/* Left Column */}
  <Grid item xs={12} sm={6}>
    <List>
      {courseCategories[tabValue].courses.slice(0, halfIndex).map((course, index) => (
        <React.Fragment key={index}>
          <ListItem
            sx={{
              backgroundColor: 'white',
              mb: 1,
              borderRadius: '8px',
              '&:hover': {
                backgroundColor: '#f0f0f0',
              },
            }}
          >
            <ListItemIcon>
              <CheckCircleIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              primary={course.title}
              primaryTypographyProps={{
                fontWeight: 500,
                fontSize: '1.1rem',
                color: 'text.primary',
              }}
            />
          </ListItem>
          {index < halfIndex - 1 && <Divider />}
        </React.Fragment>
      ))}
    </List>
  </Grid>

  {/* Right Column */}
  <Grid item xs={12} sm={6}>
    <List>
      {courseCategories[tabValue].courses.slice(halfIndex).map((course, index) => (
        <React.Fragment key={index}>
          <ListItem
            sx={{
              backgroundColor: 'white',
              mb: 1,
              borderRadius: '8px',
              '&:hover': {
                backgroundColor: '#f0f0f0',
              },
            }}
          >
            <ListItemIcon>
              <CheckCircleIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              primary={course.title}
              primaryTypographyProps={{
                fontWeight: 500,
                fontSize: '1.1rem',
                color: 'text.primary',
              }}
            />
          </ListItem>
          {index < courseCategories[tabValue].courses.slice(halfIndex).length - 1 && <Divider />}
        </React.Fragment>
      ))}
    </List>
  </Grid>
</Grid>
          ) : (
            <Grid container spacing={4} justifyContent="center">
              {courseCategories[tabValue].courses.map((course, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Card
                    sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}
                  >
                    {!imageHidden || selectedCourse !== index ? (
                      <>
                        {/* Show image */}
                        <CardMedia
                          component="img"
                          height="200"
                          image={course.image}
                          alt={course.title}
                          sx={{ objectFit: 'cover', marginBottom: 2 }}
                        />
                        <CardContent sx={{ textAlign: 'center' }}>
                          <Box
                            component="div"
                            sx={{
                              display: 'inline-block',
                              bgcolor: 'primary.main',
                              color: 'common.white',
                              fontSize: '1.25rem',
                              py: 1,
                              px: 4,
                              mb: 2,
                            }}
                          >
                            {course.title}
                          </Box>
                          <Typography variant="body2" sx={{ mb: 2 }}>
                            {course.description}
                          </Typography>
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => handleReadMore(index)}
                          >
                            Read More
                          </Button>
                        </CardContent>
                      </>
                    ) : (
                      <>
                        {/* Show only details */}
                        <CardContent
                          sx={{
                            textAlign: 'center',
                            bgcolor: 'background.paper',
                            padding: 3,
                          }}
                        >
                          <Typography
                            variant="h2"
                            sx={{
                              mb: 1,
                              fontWeight: 'bold',
                              fontSize: '1.75rem',
                              color: 'primary.main',
                            }}
                          >
                            {course.title}
                          </Typography>

                          <Divider sx={{ mb: 2 }} />

                          <Typography
                            variant="h5"
                            sx={{ fontWeight: 'bold', mb: 1, fontSize: '1.25rem' }}
                          >
                            Course Details
                          </Typography>

                          <Typography
                            variant="body2"
                            sx={{
                              whiteSpace: 'pre-line',
                              textAlign: 'left',
                              lineHeight: 1.6,
                              color: 'text.secondary',
                              fontSize: '1.25rem',
                              color: 'black',
                              fontWeight: '300',
                            }}
                          >
                            {course.details}
                          </Typography>

                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleBack}
                            sx={{ mt: 2 }}
                          >
                            Back
                          </Button>
                        </CardContent>
                      </>
                    )}
                  </Card>
                </Grid>
              ))}
            </Grid>
          )}
        </Container>
        <Footer />
      </div>
    </div>
  );
};

export default Courses;
